import { FullScreenShell } from '../ui/FullScreenShell';
import type { OwnerContext } from '../../types/actividad';
import { DetalleActividadPage } from '../../pages/DetalleActividadPage';

interface AdminDetalleActividadJAModalProps {
  readonly isOpen: boolean;
  readonly actividadId: string;
  readonly ownerContext: OwnerContext;
  readonly onClose: () => void;
}

export function AdminDetalleActividadJAModal({
  isOpen,
  actividadId,
  ownerContext,
  onClose,
}: AdminDetalleActividadJAModalProps) {
  const breadcrumbLabel =
    ownerContext.tipo === 'diocesis'
      ? `JAD — ${ownerContext.nombre || 'Diócesis'}`
      : `JAN — ${ownerContext.nombre || 'Provincia'}`;

  const header = (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
      <div>
        <p className="text-sm font-semibold text-gray-700">{breadcrumbLabel}</p>
        <p className="text-xs text-amber-600 font-medium">Vista de solo lectura</p>
      </div>
    </div>
  );

  return (
    <FullScreenShell
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      variant="fullpage"
      showCloseButton={true}
    >
      <div className="p-4 md:p-6">
        <DetalleActividadPage
          actividadId={actividadId}
          ownerContext={ownerContext}
          readOnly={true}
          onBack={onClose}
        />
      </div>
    </FullScreenShell>
  );
}
